import { getEnvFromHost } from "utils/getEnvFromHost";

export default {
  withdrawal: "https://www.vodafone.de/media/downloads/pdf/504417_Widerruf.pdf",
  "privacy-policy": `https://${
    getEnvFromHost(window.location.host) === "PROD" ? "" : `${getEnvFromHost(window.location.host).toLowerCase()}.`
  }cdn.offers.vodafone.com/tnc/de/privacy-policy.html`,
  "cookie-preferences": "cookie-preferences",
  "help-and-support": "https://www.vodafone.de/privat/hilfe.html",
  accessibility: "https://www.vodafone.de/barrierefreiheit.html",
  imprint: "https://www.vodafone.de/de/rechtliches/impressum",
  "terminate-contract": "https://www.vodafone.de/einfache-kuendigung.html",
};
